/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of document being uploaded
 */
export type DocumentReferenceDocumentType = typeof DocumentReferenceDocumentType[keyof typeof DocumentReferenceDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentReferenceDocumentType = {
  ID_DOCUMENT: 'ID_DOCUMENT',
  BANK_STATEMENT: 'BANK_STATEMENT',
  BANK_LETTER: 'BANK_LETTER',
  TAX_CLEARANCE: 'TAX_CLEARANCE',
  FINANCIAL_STATEMENTS: 'FINANCIAL_STATEMENTS',
  COMPANY_REGISTRATION_CERTIFICATE: 'COMPANY_REGISTRATION_CERTIFICATE',
  PRE_LOAN_AGREEMENT: 'PRE_LOAN_AGREEMENT',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  PAYSLIP: 'PAYSLIP',
  COLLATERAL_DOCUMENT: 'COLLATERAL_DOCUMENT',
  LOAN_AGREEMENT: 'LOAN_AGREEMENT',
  DIRECTOR_ID_COPY: 'DIRECTOR_ID_COPY',
  COMPANY_REP_ID_COPY: 'COMPANY_REP_ID_COPY',
  DELEGATION_OF_AUTHORITY: 'DELEGATION_OF_AUTHORITY',
  PROOF_OF_CONTRACT: 'PROOF_OF_CONTRACT',
  EMPLOYMENT_CONTRACT: 'EMPLOYMENT_CONTRACT',
  AFFORDABILITY_ASSESSMENT: 'AFFORDABILITY_ASSESSMENT',
  EVALUATION_RESULTS: 'EVALUATION_RESULTS',
  AWARD_LETTER: 'AWARD_LETTER',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  MANAGEMENT_ACCOUNTS: 'MANAGEMENT_ACCOUNTS',
  OTHER_CORPORATE_DOCUMENT: 'OTHER_CORPORATE_DOCUMENT',
  SUPPLIER_QUOTATION: 'SUPPLIER_QUOTATION',
  SUPPLIER_BANKING_DETAILS: 'SUPPLIER_BANKING_DETAILS',
  PO_VERIFICATION: 'PO_VERIFICATION',
  CSD_REPORT: 'CSD_REPORT',
  PROGRAMME_OF_WORKS: 'PROGRAMME_OF_WORKS',
  CUSTOMER_CONTRIBUTION_EVIDENCE: 'CUSTOMER_CONTRIBUTION_EVIDENCE',
  INVOICE: 'INVOICE',
  PROOF_OF_DELIVERY: 'PROOF_OF_DELIVERY',
  DEBTOR_STATEMENT: 'DEBTOR_STATEMENT',
  DEBTOR_CONFIRMATION: 'DEBTOR_CONFIRMATION',
  DEBTOR_PAYMENT_HISTORY: 'DEBTOR_PAYMENT_HISTORY',
  CESSION: 'CESSION',
  EXPECTED_PAYMENT_CONFIRMATION: 'EXPECTED_PAYMENT_CONFIRMATION',
  SETTLEMENT_STATEMENT: 'SETTLEMENT_STATEMENT',
  ATTORNEY_CONFIRMATION: 'ATTORNEY_CONFIRMATION',
  UNDERTAKING_TO_PAY: 'UNDERTAKING_TO_PAY',
  EXPECTED_FUNDS_EVIDENCE: 'EXPECTED_FUNDS_EVIDENCE',
  CASH_FLOW_FORECAST: 'CASH_FLOW_FORECAST',
  COST_BREAKDOWN: 'COST_BREAKDOWN',
  REPAYMENT_SOURCE_EVIDENCE: 'REPAYMENT_SOURCE_EVIDENCE',
  BILL_OF_QUANTITIES: 'BILL_OF_QUANTITIES',
  PROJECT_BUDGET: 'PROJECT_BUDGET',
  PAYMENT_MILESTONES: 'PAYMENT_MILESTONES',
  PAYMENT_CERTIFICATES: 'PAYMENT_CERTIFICATES',
  ASSET_VALUATION: 'ASSET_VALUATION',
  INSURANCE_QUOTATION: 'INSURANCE_QUOTATION',
  DIRECTOR_PROOF_OF_ADDRESS: 'DIRECTOR_PROOF_OF_ADDRESS',
  CREDIT_BUREAU_REPORT: 'CREDIT_BUREAU_REPORT',
  DIRECTOR_CONSENT: 'DIRECTOR_CONSENT',
  DIRECTOR_OTHER_DOCUMENT: 'DIRECTOR_OTHER_DOCUMENT',
  APPROVAL_CONDITION_EVIDENCE: 'APPROVAL_CONDITION_EVIDENCE',
  PROOF_OF_PAYMENT: 'PROOF_OF_PAYMENT',
  MONITORING_DOCUMENT: 'MONITORING_DOCUMENT',
  REPAYMENT_EVIDENCE: 'REPAYMENT_EVIDENCE',
  COLLECTIONS_CORRESPONDENCE: 'COLLECTIONS_CORRESPONDENCE',
  LEGAL_DOCUMENT: 'LEGAL_DOCUMENT',
  CLOSURE_DOCUMENT: 'CLOSURE_DOCUMENT',
  BANK_ACCOUNT_VERIFICATION: 'BANK_ACCOUNT_VERIFICATION',
  REPRESENTATIVE_PROOF_OF_ADDRESS: 'REPRESENTATIVE_PROOF_OF_ADDRESS',
  ASSET_OWNERSHIP_DOCUMENT: 'ASSET_OWNERSHIP_DOCUMENT',
  PROPERTY_DOCUMENT: 'PROPERTY_DOCUMENT',
  COLLATERAL_CHECK_IN_FORM: 'COLLATERAL_CHECK_IN_FORM',
  PROJECT_SITE_EVIDENCE: 'PROJECT_SITE_EVIDENCE',
  OTHER: 'OTHER',
} as const;
